export const NormalizeIntegerInput = (value) => {
  if (value === null || value === undefined) return "";

  return String(value).replace(/\D/g, "");
};
